import Vue from 'vue'

export const vendorClaimActions = {
    async 'vendor-claim-model'({ dispatch, rootState }, questionnaire) {
        return await dispatch('questionnaire/generateFrontendModel', { model: rootState.auth?.user || {}, questionnaire }, { root: true })
    },
    'vendor-claim-done'({ dispatch, rootState }) {
        dispatch('user/update', { ...rootState.auth.user, is_vendor: true }, { root: true })
    },
    async 'vendor-claim-created'(vuex, { model, route }) {
        if (!auth.loggedIn) return
        const auth = JSON.parse(JSON.stringify(vuex.rootState.auth))
        if (auth.user?.email && !auth.user?.vendor_details?.email)
            vuex.commit(
                'user/setUserData',
                { ...auth.user, ...{ vendor_details: { ...(auth.user.vendor_details || {}), ...{ email: auth.user.email } } } },
                { root: true }
            )
        if (!vuex.rootState.questionnaire.isInited)
            vuex.dispatch('questionnaire/generateFrontendModel', { model: auth.user, questionnaire: model }, { root: true })
    },
    async 'vendor-claim-save'({ dispatch, rootState }, model) {
        await dispatch(
            'questionnaire/generateModel',
            {
                ...rootState.auth.user,
                ...{ wedding_details: { ...rootState.auth.user.wedding_details, style_quiz: rootState.auth.user.wedding_details.style_quiz || null } },
            },
            { root: true }
        )
        await dispatch('user/update', { ...rootState.questionnaire.generatedModel, is_vendor: true }, { root: true })
    },
}
